module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('AppScaffold', {
    attrs: {
      "grid": ""
    }
  }, [(_vm.data && !_vm.loading) ? _c('Card', [_c('h1', [_vm._v(_vm._s(_vm.$tradFor(_vm.data.terms.name)))]), _vm._v(" "), _c('nav', [_c('RoundedButton', {
    on: {
      "click": function($event) {
        _vm.$router.go(-1);
      }
    }
  }, [_vm._v(_vm._s(_vm.$trad.common.cancel))]), _vm._v(" "), _c('RoundedButton', {
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$trad.common.save))])], 1), _vm._v(" "), _c('CaddyForm', {
    attrs: {
      "data": _vm.caddyConfig
    }
  })], 1) : _c('Card', [_c('Loader', {
    attrs: {
      "loading": true
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0eb72d54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/catalog/caddy-editor.vue
// module id = 3015
// module chunks = 0